import React from 'react'
import styled from 'styled-components'
import { any } from 'prop-types'

import {
  Smashcast,
  Twitch,
  Youtube,
  YoutubeLive,
  Image,
  Facebook,
  YoutubeExtract,
} from './Providers'

const StyledMediaWrapper = styled.div`
  padding-top: 56.25%;
  position: relative;
`

const getComponent = (type) => {
  switch (type) {
    case 'smashcast':
      return Smashcast
    case 'twitch':
      return Twitch
    case 'youtube_live':
      return YoutubeLive
    case 'youtube_video':
      return Youtube
    case 'cause_video':
    case 'fundraising_event_video':
      return YoutubeExtract
    case 'facebook':
      return Facebook
    case 'image':
    case 'cause_image':
    case 'fundraising_event_image':
      return Image
    default:
      return undefined
  }
}

export const MediaEmbed = ({ livestream, ...rest }) => {
  if (!livestream) return null

  const PlayerEmbed = getComponent(livestream.type)
  if (!PlayerEmbed) return null

  return (
    <StyledMediaWrapper {...rest}>
      <PlayerEmbed channel={livestream.channel} />
    </StyledMediaWrapper>
  )
}

MediaEmbed.propTypes = {
  livestream: any,
}
